import { AddDriverDashboardModal } from '../addDriverDashboardModal';
import { RetailDriver } from './retailDriver';

export const DriversTab = ({
  carInfo,
  driversList = [],
  handleClickAction,
}) => {

  
  const nonPrimaryDrivers = Array.isArray(driversList) ? driversList?.filter((driver) => driver?.isPrimary === 0) : [];
  const primaryDriver = driversList?.filter((driver) => driver?.isPrimary === 1)?.[0] ?? []
  
  return (
    <div className="flex flex-col gap-4 justify-between pt-4 h-full">
      <div className="max-lg:hidden max-h-[120px] flex flex-col gap-4 overflow-y-auto scrollbar pr-1">
        {driversList.length > 0 ? (
          <>
          <RetailDriver driver={primaryDriver} key={'primary-driver'} carInfo={carInfo} handleClickAction={handleClickAction}/>
          {nonPrimaryDrivers.map((driver, index) => (
            <RetailDriver driver={driver} key={index} carInfo={carInfo} handleClickAction={handleClickAction}/>
          ))}
          </>
        ) : (
          <div className="flex flex-col gap-1">
            <p className="text-body">Δεν υπάρχουν καταχωρίσεις.</p>
            <h6 className="text-[#6A6A6A]">
              Πρόσθεσε οδηγούς για να εμφανιστούν στη λίστα.
            </h6>
          </div>
        )}
      </div>
      <div className='flex flex-col w-full'>
        <div className="max-lg:hidden h-[1px] w-full bg-[#A5A5A5] mb-4" />
        <AddDriverDashboardModal plateno={carInfo.plateno} text={"Πρόσθεσε οδηγό"}/>
      </div>
    </div>
  );
};
